import { render } from "./DefaultLayout.vue?vue&type=template&id=68ed447d&scoped=true&ts=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=ts"
export * from "./DefaultLayout.vue?vue&type=script&lang=ts"

import "./DefaultLayout.vue?vue&type=style&index=0&id=68ed447d&lang=scss&scoped=true"

import exportComponent from "/Users/keita/Develop/infonic/infpf-adminsite/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ed447d"]])

export default __exports__